import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { requestV1Cgi } from "../data-source/network-request";
/**
 * 修改文件夹名称
 */
export var StorageSpaceRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(StorageSpaceRequest, _DriveRequest);
  var _super = _createSuper(StorageSpaceRequest);
  function StorageSpaceRequest() {
    _classCallCheck(this, StorageSpaceRequest);
    return _super.apply(this, arguments);
  }
  _createClass(StorageSpaceRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return {
        method: 'post',
        url: '/v2/file/suite/space',
        data: {
          xsrf: getXsrfToken()
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(_ref) {
      var _result$unlimited;
      var result = _ref.result;
      return _objectSpread(_objectSpread({}, result), {}, {
        coupon: result.coupon.map(convertStoragePlan),
        docsUsed: Number(result.docsUsed),
        enterpriseTotal: Number(result.enterpriseTotal || 0),
        free: convertStoragePlan(result.free),
        total: Number(result.total),
        upgradeLeastIncr: Number(result.upgradeLeastIncr),
        used: Number(result.used),
        unlimited: (_result$unlimited = result.unlimited) !== null && _result$unlimited !== void 0 ? _result$unlimited : false,
        vip: result.vip.map(convertStoragePlan),
        weiyunUsed: Number(result.weiyunUsed)
      });
    }
  }]);
  return StorageSpaceRequest;
}(DriveRequest);
function convertStoragePlan(raw) {
  return {
    type: raw.type,
    expiry: Number(raw.expiry),
    space: Number(raw.space)
  };
}
//# sourceMappingURL=storage-space.js.map